import * as React from "react";
import {
  Avatar,
  Box, Card, Container, Typography, IconButton,
} from "@mui/material";
import ButtonComponent from "components/Button";
import {
    schema,
} from "./helper";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";

import {H2, H4, H5} from "components/CustomTypography";
import {getLocalDate, isMarketPlace} from "helpers/utils";
import {DATE_FORMAT} from "config/constants";
import ImageAlbum from "components/elements/main/ImageAlbum";
import ShopHeaderBack from "components/elements/main/ShopHeaderBack";
import ShopHeaderMiniOverlayOtherShop from "components/elements/user/shops/ShopHeaderMiniOverlayOtherShop";

const UserSellerOtherOfferView = (props) => {

    const {
        setState, selectedOtherOffer, symbol, onAddToFavlistClicked,  onCancel, otherofferdetail, isLoading, history,
    } = props;

  const {
     id, name, description, title, valid_date, images
  } = selectedOtherOffer || {};

    const {
        shop
    } = otherofferdetail || {};



    const renderOfferPhotos = () => (
        <Box>
            <ImageAlbum images={images} mainOnly={true} />
        </Box>
    );


    const renderOfferInformation = () => (
        <Box mt={2}>
            <H2 fontSize="24px" textAlign="left" title={name} ellipsis>
                {name}
            </H2>
            <H4 fontSize="14px" textAlign="left" title={description} ellipsis>
                {description}
            </H4>
            <H4 fontSize="14px" textAlign="left" title={valid_date} ellipsis>
                {valid_date && getLocalDate(valid_date, DATE_FORMAT)}
            </H4>
        </Box>
    );

    return (
        <Container>
            <ShopHeaderMiniOverlayOtherShop shopdetail={shop} history={history} />
            <ShopHeaderBack onCancel={onCancel} history={history} />
            {!isLoading && renderOfferInformation()}
            {!isLoading && renderOfferPhotos()}


        </Container>
    );
};

export default UserSellerOtherOfferView;
